import React, { useRef, useState, useEffect } from 'react';
import './TruncatedText.css'; // Стилі — нижче

function TruncatedText({ text }) {
  const textRef = useRef();
  const [isTruncated, setIsTruncated] = useState(false);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsTruncated(el.scrollHeight > el.clientHeight + 2);
    }
  }, [text]);

  return (
    <div
      className="truncated-wrapper"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        ref={textRef}
        className="truncated-text"
      >
        {text}
      </div>

      {hover && isTruncated && (
        <div className="tooltip">
          {text}
        </div>
      )}
    </div>
  );
}

export default TruncatedText;
